import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  count = 0;
  __active = false;
  set _active(v: boolean) {
    this.__active = v;
    this.active.next(v);
  }

  active = new Subject<boolean>();

  add() {
    ++this.count;
    if (!this._active) {
      if (this.count) {
        this._active = true;
        this.hide();
      }
    }
  }

  hide() {
    if (!this.count) {
      this._active = false;
    } else {
      setTimeout(() => {
        this.hide();
      }, 1000);
    }
  }

  remove() {
    --this.count;
  }
}
